/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Dropdown } from "react-bootstrap";
import { AppGlobal } from "../index.jsx";
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Icon from "./Icon.jsx";

class LangIcon extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        setTimeout(this.getCurrentLang, 500);
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    setLang = (l) => {
        AppGlobal.setLang(l);
        this.setState({ lang: l });
    }

    getCurrentLang = () => {
        this.setState({ lang: AppGlobal.getCurrentLang() });
    }

    render() {
        return <>
            <Dropdown className={'no-arrow' + (this.props.className ? ' ' + this.props.className : '')}>
                <Dropdown.Toggle>
                    {this.state.lang?.toUpperCase()} <Icon icon="faEarthAmericas" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => this.setLang('en')} active={this.state.lang === 'en'}>English</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.setLang('es')} active={this.state.lang === 'es'}>Espa&ntilde;ol</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>;
    }
}

export default withParamsAndNavigate(LangIcon);